<template>
  
</template>

<script>
import storeGetDataMixin from '@/mixins/storeGetDataMixin.vue'
export default {
  props:['storeName'],
  mixins : [storeGetDataMixin],
  computed:{
    posStore(){
      return this.posPage.$refs[this.storeName]
    },
    store(){
      return this.posStore
    }
  },
  data () { return {
    timestamps:{
        dateKey:'month',
        from: undefined,
        to: undefined,
      },
      queryOptions:{
        groupByDate: 'transaction_date',
        selectByDate: 'settlement_date',
      },
      data:{
        RCGB: {isLoading: false, pos:undefined},
        RMGB: {isLoading: false, pos:undefined},
        RMGB_FULL: {isLoading: false, pos:undefined},
        WGB : {isLoading: false, pos:undefined},
      },
      pivotedData:{},
  }
  },
  mounted() {
    console.log('POSStore mounted')
  },
  computed:{

  },
  methods: {
    loadData: function(){
      if (!document.hasFocus())
        return;
        
      //Strip timezone from ts 
      //Not sure if this is needed since I'm get the ts from the server
      let  from = moment(this.timestamps.from).startOf(this.timestamps.dataKey).format("YYYY-MM-DD HH:mm:ss");
      let  to = moment(this.timestamps.to).endOf(this.timestamps.dataKey).format("YYYY-MM-DD HH:mm:ss");
      //Skip if from and to are the same
      if(from === to){
        console.log(from, to)
        console.log('skipping')
        return
      }

      ['RMGB_FULL', ...this.$locations].forEach(location=>{
        let data = { location, from: this.timestamps.from, to: this.timestamps.to, options:this.queryOptions }
        this._postData('/Reports/getPOSSummary', 'pos', location, data)
      })
    },

    pivotData(location){
      if(this.data[location] === undefined || this.data[location].isLoading || this.data[location].pos.count === 0){
        return
      } 
      const data = this.data[location].pos
      const rowKeys = ['date']
      const colKeys = ['card_type_key', 'device_number']
      // produce two sets of data from the records
      // sum this.[location].pos.amount
      // sum this.[location].pos.count and name it trans_count
      const functions = [['sum', 'amount'], ['sum', 'count', '#']]
      const pivot = this.$pivot.pivot(data, rowKeys, colKeys, functions);
      
      const keyOrder = ['Interac', 'VISA', 'M/C', 'Amex', 'Discovery']
      const pivotArray = this.$pivot.toArray(pivot, keyOrder, ' - ');
      this.pivotedData[location] = pivotArray
      return pivotArray;
    },
    totals(location){
      const totals = this.$math.sumKeys(this.data[location].pos)
      totals.date = 'Total'
      totals.device_number = ''
      return [totals];
    },
    pivotTotals(location){
      console.log('DEBUG Pivot Totals', location)
      console.log(this.pivotedData[location])
      const totals = this.$math.sumKeys(this.pivotedData[location])
      console.log(totals)
      totals.date = 'Total'
      console.log('DEBUG', location, totals)
      return [totals];
    },
  
  }
}
</script>